import {
  AxleCapacityField,
  AxleFormName,
  AxleGroupField,
  AxleSpacingField,
  AxleTypeField,
  AxleWeightField,
  AxleWidthField,
  IsSteeringAxleField,
  SuspensionTypeField,
  TireCountField,
  TireRatingField,
  TireSizeField,
} from '@src/permitField/AxleInformationFields';
import { TractorAxlesFormUtils } from '@src/permitField/TractorAxlesFormUtils';
import * as yup from 'yup';

const TractorAxleSpacingValidator = yup
  .number()
  .transform((value) => (value === null ? 0 : value))
  .typeError('isNumber')
  .min(0)
  .when('$mode', {
    is: 'completeApplication',
    then: (schema) =>
      schema.test('isRequired', 'isRequired', (value, context) => {
        return context.path ===
          `${TractorAxlesFormUtils.pathToAxles}[0].${AxleSpacingField.fieldName}`
          ? true
          : !!value;
      }),
    otherwise: (schema) => schema,
  });

const axleFieldsWithoutAxleCount = {
  [AxleWeightField.fieldName]: AxleWeightField.validator,
  [AxleSpacingField.fieldName]: TractorAxleSpacingValidator,
  [TireCountField.fieldName]: TireCountField.validator,
  [TireRatingField.fieldName]: TireRatingField.validator,
  [AxleCapacityField.fieldName]: AxleCapacityField.validator,
  [AxleWidthField.fieldName]: AxleWidthField.validator,
  [AxleTypeField.fieldName]: AxleTypeField.validator,
  [TireSizeField.fieldName]: TireSizeField.validator,
  [SuspensionTypeField.fieldName]: SuspensionTypeField.validator,
  [AxleGroupField.fieldName]: AxleGroupField.validator,
  [IsSteeringAxleField.fieldName]: IsSteeringAxleField.validator,
};

const optionalAxlesFields = {
  [AxleWeightField.fieldName]: AxleWeightField.validator.notRequired(),
  [AxleSpacingField.fieldName]: AxleSpacingField.validator.notRequired(),
  [TireCountField.fieldName]: TireCountField.validator.notRequired(),
  [TireRatingField.fieldName]: TireRatingField.validator.notRequired(),
  [AxleCapacityField.fieldName]: AxleCapacityField.validator.notRequired(),
  [AxleWidthField.fieldName]: AxleWidthField.validator.notRequired(),
  [AxleTypeField.fieldName]: AxleTypeField.validator.notRequired(),
  [TireSizeField.fieldName]: TireSizeField.validator.notRequired(),
  [SuspensionTypeField.fieldName]: SuspensionTypeField.validator.notRequired(),
  [AxleGroupField.fieldName]: AxleGroupField.validator.notRequired(),
  [IsSteeringAxleField.fieldName]: IsSteeringAxleField.validator.notRequired(),
};

export const axleRowFields = axleFieldsWithoutAxleCount;

export const OptionalAxleSchema = yup.object().shape(optionalAxlesFields);
export const OptionalTractorAxlesSchema = yup.object().shape({
  ...optionalAxlesFields,
  [AxleSpacingField.fieldName]: TractorAxleSpacingValidator,
});

//This is the schema when completing an order form
export const AxleInformationInputsSchema = yup.object().shape(axleRowFields);

export const AllAxlesInformationInputsSchema = yup.object().shape({
  [AxleFormName]: yup.array(AxleInformationInputsSchema),
});

export const TractorAxlesInputsSchema = yup.object().shape({
  [TractorAxlesFormUtils.fieldName]: AllAxlesInformationInputsSchema,
});
